
















import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import Member from '@/business/home/components/member.vue'

@Component({
  components: { Member, RespondecoResponsiveImage },
})
export default class RespondecoAboutUs extends Vue {
  public members: string[] = ['Andrea', 'Antje', 'Elke', 'Jan', 'Klaus', 'Roland']
}
